import { render, staticRenderFns } from "./SocialResponsibility.vue?vue&type=template&id=3ebbb67f&scoped=true"
import script from "./SocialResponsibility.vue?vue&type=script&lang=js"
export * from "./SocialResponsibility.vue?vue&type=script&lang=js"
import style0 from "./SocialResponsibility.vue?vue&type=style&index=0&id=3ebbb67f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebbb67f",
  null
  
)

export default component.exports